import axiosInstance from "../utils/axios"



export const createSubTopic =async (payload)=>{
  try {
    const headers= {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    } 
     return await axiosInstance.post(`/api/create-subtopic`, payload, {headers})

    } catch (error) {
       throw error
    }
}

export const getSubTopic =async (payload)=>{
  console.log(payload)
  try {
    const headers= {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    } 

    const params={
        name: payload?.name
    }
    return await axiosInstance.get(`/api/subtopics`, {headers, params:{...payload}})

    } catch (error) {
       throw error
    }
}

export const deleteSubTopic =async (topicId)=>{
  console.log(topicId)
  try {
    const headers= {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    } 
     return await axiosInstance.delete(`/api/subtopic/${topicId}`, {headers})

    } catch (error) {
       throw error
    }
}
export const getSubTopicById =async (payload)=>{
  console.log(payload)
  try {
    const headers= {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    } 

    const params={
        name: payload?.name
    }
    return await axiosInstance.get(`/api/subtopic/:id`, {headers, params:{...payload}})

    } catch (error) {
       throw error
    }
}
export const updateSubTopic =async (payload,topicId)=>{
  // console.log(payload)
  console.log(topicId)
  try {
    const headers= {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    } 
    return await axiosInstance.put(`/api/update-subtopic/${topicId}`,payload,{headers})

    } catch (error) {
       throw error
    }
}